import React from "react"
import { BottomSheetProps } from "components/atoms/BottomSheet/bottomSheet.types"
import SwipeableBottomSheet from "components/atoms/BottomSheet/SwipeableBottomSheet"
import UnswipeableBottomSheet from "components/atoms/BottomSheet/UnswipeableBottomSheet"

export default function BottomSheet(props: BottomSheetProps) {
  const { swipeable = true, children, ...otherProps } = props
  return (
    swipeable ? <SwipeableBottomSheet {...otherProps}>{children}</SwipeableBottomSheet> :
      <UnswipeableBottomSheet {...otherProps}>{children}</UnswipeableBottomSheet>
  )
}
